import { Injectable } from '@angular/core';
import { loadRemoteModule } from '@nx/angular/mf';

type RemoteModule = any;

@Injectable({
    providedIn: 'root',
})
export class MicroFrontendService {
    private remoteModuleMap = new Map<string, Promise<RemoteModule>>();
    DEFAULT_MODULE = './Module';
    
    constructor() {}

    private generateKey(mfeName: string, entryPoint: string) {
        return `${mfeName} - ${entryPoint}`;
    }

    getRemoteModule(mfeName: string, entryPoint: string) {
        const moduleKey = this.loadRemoteModule(mfeName, entryPoint);
        const preloadedModule = this.getLoadedMfeModule(moduleKey);
        return preloadedModule;
    }

    loadRemoteModule(mfeName: string, entryPoint = this.DEFAULT_MODULE) {
        const moduleKey = this.generateKey(mfeName, entryPoint);
        if (this.remoteModuleMap.has(moduleKey)) {
            return moduleKey;
        }
        const remoteModule = loadRemoteModule(mfeName, entryPoint);
        this.remoteModuleMap.set(moduleKey, remoteModule);
        return moduleKey;
    }

    getLoadedMfeModule(moduleKey: string) {
        return this.remoteModuleMap.get(moduleKey);
    }
}
